export default __webpack_public_path__ + "static/media/SR.c4927c87.svg";